import { IAddFeaturesToStore } from '~/Actions/ActionFeaturesType';
import { Dispatch } from 'react';
import client from '~/client';
import { GRAPHQL_QUERIES_MAP } from '~/queries/helpers';
import { settings } from '~/utils/settings';
import { logInfo } from '~/utils/logging';
import { LocalStorageHelper } from '~/utils/storage';

export const ADD_FEATURES_TO_STORE = 'ADD_FEATURES_TO_STORE';

export const addFeaturesToStore = (shipFeatureMap: ShipFeatureMap): IAddFeaturesToStore => {
    return {
        type: ADD_FEATURES_TO_STORE,
        shipFeatureMap,
    };
};

export const loadFeatures = () => {
    return async (dispatch: Dispatch<IAddFeaturesToStore>): Promise<void> => {
        const data: { shipFeatureMap: ShipFeatureMap } = {
            shipFeatureMap: {},
        };

        const shipFeatureStorage = LocalStorageHelper.get('shipFeatures');

        if ((shipFeatureStorage?.version === settings.version || !settings.version) && shipFeatureStorage?.lang === settings.languageCode && shipFeatureStorage?.data) {
            dispatch(addFeaturesToStore(shipFeatureStorage?.data));
        } else {
            await client
                .get()
                .query({
                    query: GRAPHQL_QUERIES_MAP['FEATURES'],
                    variables: {
                        lang: settings.languageCode,
                    },
                })
                .then((response) => {
                    response.data?.features?.forEach((feature: IFeaturesItem) => {
                        data.shipFeatureMap[feature.id] = feature;
                    });
                })
                .catch(() => {
                    logInfo('response not successful for item');
                });

            LocalStorageHelper.set('shipFeatures', { version: settings.version, lang: settings.languageCode, data: data.shipFeatureMap });

            dispatch(addFeaturesToStore(data.shipFeatureMap));
        }
    };
};
